/**
 * CollectionHeader class represents a custom web component that extends HTMLElement.
 * It provides functionality to toggle between truncated and full descriptions with a "Read more" button.
 */
class CollectionHeader extends window.HTMLElement {
  // Initialize properties
  open = false
  descriptionWrapper = undefined
  truncDescription = ''
  fullDescription = ''
  originalHeight = 0
  buttonTrigger = undefined
  readLessText = 'Read less'
  readMoreText = 'Read more'

  constructor() {
    super()
    this.setupReadMore()
  }

  /**
   * Sets up the "Read more" functionality for the collection header.
   */
  setupReadMore() {
    this.buttonTrigger = this.querySelector('[read-more]')

    if (!this.buttonTrigger) {
      return
    }

    // Get elements and attributes needed for toggling
    this.descriptionWrapper = this.querySelector('[description-read-more]')
    this.originalHeight = this.descriptionWrapper.scrollHeight
    this.truncDescription = this.descriptionWrapper.innerHTML
    // this.fullDescription =
    //   this.descriptionWrapper.getAttribute('data-full-content')
    this.fullDescription = document.querySelector(
      '[data-full-description]'
    ).innerHTML

    // Set text content based on attributes
    this.readLessText = this.buttonTrigger.getAttribute('data-read-less-text')
    this.readMoreText = this.buttonTrigger.innerHTML

    // Add event listeners for clicking and toggling
    this.buttonTrigger.addEventListener('click', this.toggle.bind(this))
    this.descriptionWrapper.addEventListener('click', this.toggle.bind(this))

    // Set initial max height
    this.setMaxHeight()
  }

  /**
   * Sets the max height of the description wrapper.
   * @param {number} height - The height to set the max height to (default is full height).
   */
  setMaxHeight(height = this.descriptionWrapper.scrollHeight) {
    this.descriptionWrapper.style.maxHeight = `${height}px`
    console.log('height', height)
  }

  /**
   * Toggles between truncated and full descriptions when the button is clicked.
   */
  toggle() {
    this.open = !this.open

    if (this.open) {
      this.descriptionWrapper.innerHTML = this.fullDescription
      this.setMaxHeight()
      this.buttonTrigger.innerHTML = this.readLessText
    } else {
      this.setMaxHeight(this.originalHeight)
      this.buttonTrigger.innerHTML = this.readMoreText

      // Reset description to truncated version after a delay
      setTimeout(() => {
        this.descriptionWrapper.innerHTML = this.truncDescription
      }, 150)
    }
  }
}

// Define the 'collection-header' custom element using the CollectionHeader class.
window.customElements.define('collection-header', CollectionHeader)
